import { i18n } from 'src/boot/i18n';

const maxValue = 200000000
export default class InputHelper {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static ValidateNumber(val : any): boolean | string{
    console.log(val);
    if (!val) {
      return i18n.t('required').toString()
    } else if ( Number(val) == Number.NaN || isNaN(val)) {
      return i18n.t('numericValue').toString()
    } else if (Number(val) > maxValue){
      return i18n.t('valueLessThan', {maxValue : maxValue}).toString()
    }

    return true;
  }
}
